__turbopack_context__.v({
  "root": "DataIncomplete-module-scss-module__VCyowq__root",
});
